module.exports = __webpack_public_path__ + "6ae73f2aaad59e1b68df1a3688d4c477.jpg";